// src/pages/OldApp.js
import React from "react";

export default function OldApp() {
  return (
    <iframe
      src="/old_app/old_app.html"
      title="Old Routing Web App"
      style={{
        position: "absolute",
        top: "63px",
        left: 0,
        width: "100%",
        height: "calc(100% - 63px)",
        border: "none",
      }}
    />
  );
}
